import React, { useState, useEffect } from "react";
import { ApiService } from "../services";
import { Delete } from "@material-ui/icons";
import GEditable from "../gComponents/gEditable";
import GButton from "../gComponents/gButton";
import SocialLinkForm from "../forms/socialLinkForm";
import GEmpty from "../gComponents/gEmpty";
import GConfirmDialog from "../gComponents/gConfirmDialog";
import { useSnackbar } from "react-simple-snackbar";
import Modal from "react-modal";

export default function SocialLinks(props) {
  const [linksData, setLinksData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedSocialData, setSelectedSocialData] = useState({});
  const [selectedSocialId, setSelectedSocialId] = useState("");
  const [csvisible, setCsvisible] = React.useState(false);
  const [isEmpty, setIsEmpty] = useState(true);
  const [openSnackbar] = useSnackbar();

  useEffect(() => {
    getSocialSettings();
  }, []);

  const getSocialSettings = () => {
    ApiService({ method: "GET", route: "social" })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          setLinksData(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function updateField(newValue, selectedFieldId) {
    console.log(newValue);
    console.log(selectedFieldId);
    // return;
    var send_data = {
      url: newValue,
    };
    var hitUrl = "social/" + selectedFieldId;
    ApiService({ method: "PUT", route: hitUrl, body: send_data })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 1) {
          getSocialSettings();
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const deleteSocialLink = () => {
    var hitUrl = "social/" + selectedSocialId;
    ApiService({ method: "DELETE", route: hitUrl })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          getSocialSettings();
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // We can use the `useParams` hook here to access
  // the dynamic pieces of the URL.

  return (
    <div className="rightInnerView">
      <h2>
        Social Links
        <GButton
          variant="condensed"
          children="Add"
          onClick={() => {
            setSelectedSocialData({});
            setIsEmpty(true);
            setCsvisible(true);
          }}
          style={{
            float: "right",
          }}
        >
          Add
        </GButton>
      </h2>
      <div className="listPaper">
        {linksData.length > 0 ? (
          linksData.map((link, i) => (
            <div style={{ display: "inline-flex", width: "80%" }} key={i}>
              <GEditable
                key={link.id}
                type="text"
                title={true}
                defaultValue={link.url}
                className={props.title}
                placeholder={link.title}
                id={link.id}
                onSubmit={updateField}
                style={{
                  margin: "10px 0 20px",
                  width: "70%",
                  paddingRight: "20px",
                  boxSizing: "border-box",
                }}
              />
              <GButton
                variant="linkable"
                onClick={(e) => {
                  setSelectedSocialId(link.id);
                  setDialogOpen(true);
                }}
                style={{ paddingTop: "20px" }}
              >
                <Delete fontSize="small" />
              </GButton>
            </div>
          ))
        ) : (
          <GEmpty subtitle="No Social links found"></GEmpty>
        )}
      </div>

      {dialogOpen === true ? (
        <GConfirmDialog
          open={dialogOpen}
          title="Delete Social Link"
          text="Are you sure you want to delete this link?"
          handleClose={() => setDialogOpen(false)}
          onConfirmClose={() => {
            setDialogOpen(false);
            deleteSocialLink();
          }}
        ></GConfirmDialog>
      ) : (
        ""
      )}

      <Modal
        isOpen={csvisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setCsvisible(false)}
        style={{
          content: {
            width: "400px",
          },
        }}
        contentLabel="Social Link Form Modal"
      >
        <SocialLinkForm
          csvisible={csvisible}
          setCsvisible={setCsvisible}
          data={selectedSocialData}
          onSubmit={getSocialSettings}
          isEmpty={isEmpty}
        />
      </Modal>
    </div>
  );
}
